import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const VisitsToGovtOfficesSchoolsByMeenu = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Visits to govt. offices/schools by Meenu" />
    </Box>
  );
};
